/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_TaskManagerService_Dtos_TaskStatus_TaskStatusDto } from '../models/Wealthlane_TaskManagerService_Dtos_TaskStatus_TaskStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaskStatusService {

    /**
     * @returns Wealthlane_TaskManagerService_Dtos_TaskStatus_TaskStatusDto OK
     * @throws ApiError
     */
    public static getApiTaskmanagerApiAppTaskStatusTaskStatusList(): CancelablePromise<Array<Wealthlane_TaskManagerService_Dtos_TaskStatus_TaskStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/taskmanager/api/app/task-status/task-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
